<template>
  <v-navigation-drawer :clipped="$vuetify.breakpoint.lgAndUp" app :value="drawer" @input="$emit('input', $event)">
    <v-list nav>
      <v-list-item :to="{ name: 'orders' }">
        <v-list-item-icon>
          <v-icon>$vuetify.icons.orders</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ $vuetify.lang.t('$vuetify.navigation.orders') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :to="{ name: 'customers' }">
        <v-list-item-icon>
          <v-icon>$vuetify.icons.customers</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ $vuetify.lang.t('$vuetify.navigation.customers') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    drawer: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
